module.exports = __webpack_public_path__ + "static/media/ro1.d3b31761.jpg";